import React from 'react';
const HowToStartStep = ({howtoMeta, children}) => <span id={ howtoMeta.urlId }>{children}</span>;

export {
    HowToStartStep
};